import React, { useState, useEffect } from 'react';
import LegalModal from '../LegalModal';
import { getLegalContent } from '../../services/legalService';

type LegalModalType = 'terms' | 'privacy' | null;

const DEFAULT_PREFIX = 'By continuing, you agree to our';

const buttonClass =
  'text-cyan-400 hover:text-cyan-300 underline bg-transparent border-none cursor-pointer p-0 focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:ring-offset-2 focus:ring-offset-gray-800 rounded';

interface LegalAgreementLineProps {
  /** Wrapper paragraph className (e.g. "text-xs text-center text-gray-400") */
  className?: string;
  /** Optional prefix before "Terms of Service and Privacy Policy". Default: "By continuing, you agree to our" */
  prefix?: string;
}

const LegalAgreementLine: React.FC<LegalAgreementLineProps> = ({
  className = 'text-xs text-center text-gray-400',
  prefix = DEFAULT_PREFIX,
}) => {
  const [legalModal, setLegalModal] = useState<LegalModalType>(null);
  const [termsMarkdown, setTermsMarkdown] = useState('');
  const [privacyMarkdown, setPrivacyMarkdown] = useState('');

  useEffect(() => {
    getLegalContent().then((content) => {
      setTermsMarkdown(content.terms_markdown ?? '');
      setPrivacyMarkdown(content.privacy_markdown ?? '');
    });
  }, []);

  return (
    <>
      <p className={className}>
        {prefix}{' '}
        <button type="button" onClick={() => setLegalModal('terms')} className={buttonClass}>
          Terms of Service
        </button>
        {' '}and{' '}
        <button type="button" onClick={() => setLegalModal('privacy')} className={buttonClass}>
          Privacy Policy
        </button>.
      </p>

      <LegalModal
        open={legalModal === 'terms'}
        onClose={() => setLegalModal(null)}
        title="Terms of Service"
        markdown={termsMarkdown}
      />
      <LegalModal
        open={legalModal === 'privacy'}
        onClose={() => setLegalModal(null)}
        title="Privacy Policy"
        markdown={privacyMarkdown}
      />
    </>
  );
};

export default LegalAgreementLine;
